type GraphData = {
  children: string;
};

export const skillsProfileTreemapChartConfig = (graphData: GraphData) => ({
  series: [
    {
      name: "ProFinda",
      type: "treemap",
      id: "skills_profile_section_graph",
      animationDurationUpdate: 1000,
      roam: "move",
      data: graphData.children,
      universalTransition: true,
      label: {
        show: true
      },
      upperLabel: {
        show: true,
        height: 30
      },
      breadcrumb: {
        show: true
      },
      levels: [
        {
          itemStyle: {
            borderWidth: 0,
            gapWidth: 4,
            borderColor: "transparent"
          },
          upperLabel: {
            show: false
          }
        },
        {
          itemStyle: {
            gapWidth: 2,
            borderColorSaturation: 0.7,
            borderWidth: 4
          },
          upperLabel: {
            show: true,
            color: "#fff"
          }
        },
        {
          colorSaturation: [0.35, 0.5],
          itemStyle: {
            gapWidth: 1,
            borderColorSaturation: 0.6,
            borderWidth: 4
          },
          upperLabel: {
            show: true,
            height: 24,
            color: "#fff"
          }
        }
      ]
    }
  ]
});
